


function LogisticsPage() {

  const [page, setPage] = React.useState("option")
  const [user, setUser] = React.useState(null)
  const [option, setOption] = React.useState(null)
  const [chosenLocation, setChosenLocation] = React.useState(null)
  const [position, setPosition] = React.useState([])

  // user location
  const [province, setProvince] = React.useState('');
  const [city, setCity] = React.useState('');
  const [country, setCountry] = React.useState('Colombia');

  const business = window.business
  const $ = window.jQuery

  let base = new window.BasePage()

  React.useEffect(() => {

    base.addStyling(business)

    //console.log("OffersPage useEffect", window.business, window.user)

    setUser(window.user)

    base.getCurrentUserLocation((position, city, province, country) => {
      setPosition(position)
      setProvince(province);
      setCity(city)
      setCountry(country)
    }, error => {
      console.log("Error getting location", error)
    })

    base.startCarousel(window.carouselImages)

  }, [])


  const doSendCode = (name, email, phone) => {
    //console.log("doSendCodes")

    if (name == '' || email == '' || phone == '') {
      alert("Por favor ingrese su nombre, correo y teléfono")
      return
    }

    $("#join_button").hide()

    let nonce = generateNonce(32);

    let data = {
      name: name.trim(),
      phone: fixupPhone(phone),
      email: fixupEmail(email),
      city: city,
      province: province,
      country: country,
      n: nonce,
    }

    // create a nonce and a token to sign the request
    let apk = "8289f056-1a48-461d-821c-86c4fb74462e"

    let txt = `${data.name}-${apk}-${data.email}-${nonce}`

    data.s = signString(txt)

    //console.log("doSendCode data", data)

    base.generateCode(data, (response) => {
      //console.log("code_for_credentials response", response)

      setPage("code")

    }, (response) => {
      console.log("code_for_credentials response", response)
      let txt = response.responseText

      $("#join_button").show()
    })

  }

  const DriverContent = () => {

  }

  const DeliveryContent = () => {

  }

  const TransportContent = () => {

  }

  const ChooseOptionContent = () => {
    return <div className="mx-2">
      <div className="row logo-row"   >
        <div className="col centered"><img src={business.photo} width={80} /></div>
      </div>

      {base.assetsRow(business)}

      <div className="row"  >
        <div className="col centered"><span>{business.description}</span></div>
      </div>

      <div className="row"  >
        <div className="col centered"><h4>Logistics</h4></div>
      </div>

      <div className="row"  >
        <div className="col centered"><span>¿Cual servicio necesitas?</span></div>
      </div>

      <div className="row m-4 "  >
        <div className="landing-page-button centered br-15" onClick={() => setPage("driver")} >
          <div className="row ">
            <div className="col centered">
              <img src="/images/taxidriver.jpeg" width={120} className="br-5" />
            </div>
            <div className="col centered vertical-center">
              <h1>Conductor</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-4 "  >
      <div className="landing-page-button centered br-15" onClick={() => setPage("delivery")} >
          <div className="row ">
            <div className="col centered">
              <img src="/images/domidriver.jpeg" width={120} className="br-5" />
            </div>
            <div className="col centered vertical-center">
              <h1>Domicilio</h1>
            </div>
          </div>
        </div>
        </div>

        <div className="row m-4 "  >
      <div className="landing-page-button centered br-15" onClick={() => setPage("driver")} >
          <div className="row ">
            <div className="col centered">
              <img src="/images/deliverytruck.jpeg" width={120} className="br-5" />
            </div>
            <div className="col centered vertical-center">
              <h1>Transporte</h1>
            </div>
          </div>
        </div>
        </div>



    </div>
  }


  function getContent() {
    if (page == "driver") {
      return <DriverContent />
    } else if (page == "delivery") {
      return <DeliveryContent />
    } else if (page == "transport") {
      return <TransportContent />
    } else if (page == "identity") {
      return <IdentityContent />
    } else if (page == "code") {
      return <CodeContent />
    }

    return <ChooseOptionContent />
  }

  return (
    <div className="business-container"  >

      {getContent()}

      <div className="centered">
        <div className="social-row  ">
          <div>
            &nbsp;

          </div>
          <div>
            {base.twitterButton(business)}
            {base.facebookButton(business)}
            {base.whatsappButton(business)}
            {base.instagramButton(business)}
            {base.youtubeButton(business)}
          </div>
          <div>
            &nbsp;
          </div>

        </div>
      </div>

      <div className="row  powered-row">
        <div className="col centered"><span>Powered By</span></div>
      </div>

      <div className="row logo-row">
        <a href="https://zono.cc" target="blank">
          <div className="col centered"><img src="/images/zono-smile.png" width={100} /></div>
        </a>
      </div>


      <div style={{ width: '100%', marginTop: 10 }}>
        <div className="pb-2 mt-2 text-center ">
          <div >© Copyright 2023 Zono.cc All Rights Reserved</div>
        </div>
      </div>


    </div>
  )
}

window.LogisticsPage = LogisticsPage